import React, {Component} from 'react';
import {browserHistory} from 'react-router'

class Header extends Component {
    constructor(props) {
        super(props);
        this.getAppointments = this.getAppointments.bind(this);
        this.toChooseServices = this.toChooseServices.bind(this);
        this.log_out = this.log_out.bind(this);
    }

    toChooseServices(e) {
        e.preventDefault(e);
        browserHistory.push(`/ChooseServices`)
    }

    getAppointments() {
        browserHistory.push(`/MyAccount`)
    }

    log_out() {
        localStorage.removeItem("servicesData");
        localStorage.removeItem("appointment_details");
        localStorage.removeItem("appointment");
        localStorage.removeItem("services");
        localStorage.removeItem("user");
        browserHistory.push(`/StepOne`)
    }

    dispatchLogoUrl = (e) => {
        if (window.location.pathname === '/MyAccount') {
            this.toChooseServices(e);
        }
    };

    render() {
        let pageState = this.props.pageState;
        let step = 1;
        let getPageState = function () {
            switch (pageState) {
                case '/StepTwo':
                    step = 2;
                    break;
                case '/StepThree':
                    step = 3;
                    break;
                case '/StepFour':
                    step = 4;
                    break;
                case '/ForgotPassword':
                    step = 5;
                    break;
                default:
                    step = 1;
                    break;
            }
        };

        getPageState();

        let user = localStorage.getItem('user');

        return (
            <header>
                <div className="navbar navbar-default" role="navigation">
                    <div className="container">
                        <div className="navbar-header">
                           <a
                                className="navbar-brand"
                                href="https://gostylu.com/"
                                onClick={this.dispatchLogoUrl}
                            >GoStylu</a>
                        </div>
                        { step != 5 &&
                        <ol className="progression progress--large hidden-xs">
                            <li className={step === 1 ? 'is-active' : ''} id="step1" data-step="1">
                                <a disabled="disabled">Select My Services</a>
                            </li>
                            <li className={step === 2 ? 'is-active' : ''} id="step2" data-step="2">
                                <a disabled="disabled">Appt. Details</a>
                            </li>
                            <li className={step === 3 ? 'is-active' : ''} data-step="3">
                                <a id="ctl00_lnkbtnStep3" disabled="disabled">Appt. Location</a>
                            </li>
                            <li className={step === 4 ? 'is-active' : ''} data-step="4">
                                <a id="ctl00_lnkbtnStep4" disabled="disabled">Check Out</a>
                            </li>
                        </ol>
                        }
                        {
                            user &&
                            <p className="my-account-link">
                                <span className="my-account-link-container">
                                    <a
                                        className="myAccount"
                                        href="#"
                                        style={{"text-decoration": "none"}}
                                        onClick={this.getAppointments}
                                    >My Account</a>
                                    <a className="myAccount m-myAccount"
                                       href="#"
                                       onClick={this.log_out}
                                    >Log Out</a>
                                </span>
                            </p>
                        }
                    </div>
                </div>
            </header>
        )
    }
}

export default Header;



/** WEBPACK FOOTER **
 ** ./src/Header.js
 **/